module.exports = "/_next/static/images/5c285b076151673f1e5f2a724b565860-qr-to-app-v1.svg";